module.exports = __webpack_public_path__ + "static/img/hat.10881f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sass/images/clothes/hat.png
// module id = jk1Q
// module chunks = 1